import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useUrlAndHashFromPath } from '@/hooks/useUrlAndHashFromPath';
import { useAdDetails } from '@/views/Ads/useAdDetails';

export function useAdPathSynchronizer() {
  const router = useRouter();
  const { clearUrl, hash, queryString } = useUrlAndHashFromPath();
  const { adDetails } = useAdDetails();

  function synchronizePath() {
    const adPath = adDetails?.path;

    if (adPath && adPath !== clearUrl) {
      const newPath = [
        adPath,
        queryString && `?${queryString}`,
        hash && `#${hash}`,
      ].reduce((acc, part) => (part ? acc + part : acc), '');

      router.replace(newPath);
    }
  }

  useEffect(() => {
    synchronizePath();
  }, [adDetails?.path]);
}
